/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const ListSmallIcon = React.forwardRef<HTMLDivElement, BaseIconProps>(
  ({size = 16, ...props}, ref) => {
    return (
      <BaseIcon {...props} size={size} ref={ref}>
        <svg
          data-wf-icon="ListSmallIcon"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <g>
              <path
                d="M3.5 4.5C4.05228 4.5 4.5 4.05228 4.5 3.5C4.5 2.94772 4.05228 2.5 3.5 2.5C2.94772 2.5 2.5 2.94772 2.5 3.5C2.5 4.05228 2.94772 4.5 3.5 4.5Z"
                fill="currentColor"
              />
              <path d="M6 4H14V3H6V4Z" fill="currentColor" />
              <path d="M6 8H14V7H6V8Z" fill="currentColor" />
              <path d="M6 12H14V11H6V12Z" fill="currentColor" />
              <path
                d="M4.5 7.5C4.5 8.05229 4.05228 8.5 3.5 8.5C2.94772 8.5 2.5 8.05229 2.5 7.5C2.5 6.94772 2.94772 6.5 3.5 6.5C4.05228 6.5 4.5 6.94772 4.5 7.5Z"
                fill="currentColor"
              />
              <path
                d="M3.5 12.5C4.05228 12.5 4.5 12.0523 4.5 11.5C4.5 10.9477 4.05228 10.5 3.5 10.5C2.94772 10.5 2.5 10.9477 2.5 11.5C2.5 12.0523 2.94772 12.5 3.5 12.5Z"
                fill="currentColor"
              />
            </g>
          </g>
        </svg>
      </BaseIcon>
    );
  }
) as IconComponent;

ListSmallIcon.tags = ['list', 'menu', 'bullets', 'tasks', 'organize'];

ListSmallIcon.category = 'Style Panel';

ListSmallIcon.iconSize = 16;
